// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-nav .nav-item p{line-height:inherit;margin-left:5px}.navbar-wrapper{width:100%;display:flex;justify-content:space-between;flex-wrap:wrap;align-items:center}.wrapper-full-page .navbar-collapse .navbar-nav,.wrapper-full-page .navbar-toggler{margin-right:30px}.navbar-collapse .navbar-nav .nav-link{width:100%;display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
